import { TighteningMethod } from '../enums/tightening-method.enum';

export class TighteningData {
    tighteningMethod: TighteningMethod;
    breakout: boolean;
    percentageCover: string;
    lubricantId: string;
    lubricantMode: string;
    kFactor: number;
    isDataValid: boolean;
}
